import { FunctionComponent } from "react";
import { CountdownProps } from "./Countdown.types";
import styles from "./Countdown.web.css";

export const Countdown: FunctionComponent<CountdownProps> = ({ text }) => (
  <span className={styles.countdown}>{text}</span>
);
